/*
 * treeReducer
 *
 *
 */

import { fromJS } from 'immutable';
import {
  SET_SOMETHING,
  SET_PRID,
  canvasBottomMargin,
  canvasSideMargin,
  userIsLoggedIn,
  heightOfPublicBottomBannerForUnSignedInUser,
  FETCH_TREE_ERROR,
  SET_UNIONS,
  SET_BRANCHES,
  SET_NODES_OBJS,
  SET_FAN_CHART_DATA,
  SET_FANCHART_UNIQUE_CHARS,
  SET_WIDTHS_NAMES_FOR_FANCHART,
  SET_IS_LARGETREE,
  SET_TEST,
  SET_NODES_OBJS_BY_NODE,
  SET_NODEOBJSBYRANGE,
  SET_COUNTOF,
  SET_LOOKUPNODEID,
  SET_PROFILE_OBJS,
  SET_VIEWPORT,
  SET_PROGRESS,
  SET_FLIPDATA,
  SET_CANVAS_WIDTH,
  SET_CANVAS_HEIGHT,
  SET_PREFERENCES,
  SET_FLOATERS,
  SET_LEGEND_DESCRIPTIONS,
  SET_RESOLVE,
  SET_CANVAS_HEIGHT_TOP,
  SET_EDGES,
  SET_FOCUSNODE,
  SET_CID_GRPS,
  SET_FIRSTTREEMATCHCOUNTNODE,
  SET_FIRSTRECORDMATCHCOUNTNODE,
  SET_FIRSTMALEGHOSTNODE,
  SET_FIRSTFEMALEGHOSTNODE,
  SET_FIRSTTREEMATCHNODE,
  SET_FIRSTDEADNODE,
  SET_FIRSTRECORDMATCHNODE,
  SET_FIRSTSMARTMATCHNODE,
  SET_FIRSTCYCLEMASTERNODE,
  SET_FIRSTMULTIPLEPARENTNODE,
  SET_FIRSTCONFLICTNODE,
  SET_FIRSTDNANODE,

  FIRSTEDITNODE,
  FIRSTEMAILREQUESTNODE,
  SET_FIRSTINCONSISTENTENCYNODE,
  SET_FIRSTMERGEPENDINGNODE,
  SET_FIRSTAPPEAR05NODE,
  SET_FIRSTAPPEAR06NODE,
  SET_FIRSTAPPEAR07NODE,
  SET_FIRSTAPPEAR08NODE,
  SET_FIRSTAPPEAR09NODE,
  SET_NUMOFGENERATIONS,

  isDevelopment,
  hasTreeActivationBanner,
  hasExpiringProUpsell,
  activeNoticeBannerHeight,
  initialCanvasTopDesktopMargin,
  defaultCanvasTop,
} from '../library/constants';

import {  isMobilePhone,
  doesExpiringUpsellExist,
} from '../library/calc';

let canvasTop = 58;
let canvasHeight = window.innerHeight - ( initialCanvasTopDesktopMargin + ( isMobilePhone() ? 0 : canvasBottomMargin));
canvasHeight = ( doesExpiringUpsellExist && !isMobilePhone() ? canvasHeight - 49 : canvasHeight);
canvasHeight = ( !userIsLoggedIn ? canvasHeight - heightOfPublicBottomBannerForUnSignedInUser : canvasHeight);

if (isMobilePhone() && userIsLoggedIn){ // bookmarkPleaseRemove userIsLoggedIn
  canvasTop = 58;
  canvasHeight += 0;
  if( hasTreeActivationBanner || hasExpiringProUpsell ){
    canvasHeight -= 60;
  }
};

const canvasWidth = window.innerWidth - (canvasSideMargin * 2);
let shiftDownCanvasTop = 0;

if( document.querySelector('.page_body') ){
  const realCanvasTop =  document.querySelector('#yui-main').getBoundingClientRect().top + window.scrollY;
  shiftDownCanvasTop = realCanvasTop - defaultCanvasTop;
}

if( isDevelopment ){
  canvasTop = 63;
  canvasHeight = canvasHeight = window.innerHeight - ( initialCanvasTopDesktopMargin + canvasBottomMargin);
  if( hasTreeActivationBanner || hasExpiringProUpsell ){
    canvasTop = 103;
    canvasHeight = 778;
  }
  // if( isMobilePhone() ) canvasHeight = 678;
}

const left = 0;
const top = 0;
const right = canvasWidth;
const bottom = canvasHeight;

const initialState = fromJS({
  prId: 0,
  data: {
    foo: {},
    err            : false,
    loaded         : false,
    test:{
      foo: '',
    },
    countOf:{
      males: 0,
      females: 0,
      ungendered: 0,
      hasPics: 0,
    },
    nodeObjs       : {},
    nodeObjsByRange: {},
    unions         : [],
    branches       : [],
    flipBoxData    : null,
    edges          : {},
    focusNode      : null,
    firstTreeMatchCountNode        : null,
    firstRecordMatchCountNode      : null,
    firstMaleGhostNode             : null,
    firstFemaleGhostNode           : null,
    firstCycleMaster               : null,
    firstTreeMatchNode             : null,
    firstRecordMatchNode           : null,
    firstSmartMatchNode            : null,
    firstDNANode                   : null,
    firstConflictNode              : null,
    firstMultipleParentNode        : null,
    uniqueChars                    : null,
    fanChartData                   : null,
  },
  ui:{
    viewport:{
      top,
      right,
      bottom,
      left,
    },
    canvas:{
      top: canvasTop,
      width: canvasWidth,
      height: canvasHeight,
      shiftDownCanvasTop
    },
    progress:{
      show: false,
      loaded: 100,  // Set initial at 100 so allows little tree to load goto list
    },
  },
  user: {
    foo: false,
    isLargeTree: false,
    nodecount: 0,
    ancestors  : null,
    descendants: null,
    scaleOfMiniMap: .22,
    scalePrintCanvas: 3,
    lowerPrintRes: false,
    floaters   : null,
    show_floaters_help   : null,
    show_middle_names   : null,
    hide_record_match_prompt   : null,
    hide_public_warning   : null,
    hide_hot_match_prompt   : null,
    // dropOnNode: null,
    resolve: {
      parents             : null,
      partnerNodeObjsArray: null,
      siblings            : null,
      children            : null,
    },
    isPedigree: false,
    isFanchart: false,
    isDualPedigree: false,
    chartType: undefined,
    maxAncestorGen: undefined,
    legendDescriptions:false,
    fanchartObj: {
      levels: 7,
    },
    dualPedigreeObj: {
      tpId: 0,  // tree poster primary key from server
      focusPrId: 0, // profile id must be in the unions delivered in fetchtree
      unionId: 0, // radio choice of union or initial one from poster/lists
      root: {
        left: 0, // starting node for left of butterfly chart
        right: 0, // starting node for right of butterfly chart
      },
      frameStyle: 0,
      hash:{},
      unions:{
        partners:[],
        parents:[]
      },
      posters: [],
    },
    show_guide: false,
    show_ancestors: false,
    date_format: undefined,
    guide_page: undefined,
    // showCardPhotos: false,
    showCardPhotos: true,
    showCardEditIcon: true,
    showCardEmailInvite: true,
    styles: undefined,
  }
});

function treeReducer(state = initialState, action) {

switch (action.type) {

  case SET_SOMETHING:
    // console.log('reducer: set_something');
    return state
      .setIn(['data', 'foo', 'boo'], action.obj.mar)
    case SET_PRID:
      // console.log('SET_PRID');
      return initialState
        .setIn(['data', 'loaded'], false)
        .set('prId', action.prId);

  case SET_IS_LARGETREE:
    // console.log('SET_IS_LARGETREE');
    return state
      .setIn(['user', 'isLargeTree'], action.isLargeTree)
      .setIn(['user', 'nodecount'], action.nodecount);
  case FETCH_TREE_ERROR:
    // console.log('FETCH_TREE_ERROR');
    return state
      .setIn(['data', 'err'], action.err);
  case SET_UNIONS:
    // console.log('SET_UNIONS');
    return state
      .setIn(['data', 'unions'], action.unions);
  case SET_BRANCHES:  // Pedigree
    // console.log('SET_BRANCHES');
    return state
      .setIn(['data', 'branches'], action.branches);
  case SET_NODES_OBJS:
    return state
      .setIn(['data', 'loaded'], true)
      .setIn(['data', 'nodeObjs'], action.nodeObjs);
  case SET_FAN_CHART_DATA:
    return state
      .setIn(['data', 'fanChartData'], action.fanChartData);
  case SET_FANCHART_UNIQUE_CHARS:
    return state
      .setIn(['data', 'uniqueFanChartChars'], action.uniqueFanChartChars);
  case SET_WIDTHS_NAMES_FOR_FANCHART:
    return state
      .setIn(['data', 'hashWidthsNamesForFanchart'], action.hashWidthsNamesForFanchart);
  case SET_NODES_OBJS_BY_NODE:
    // console.log('');
    return state
      .setIn(['data', 'nodeObjs', `"${action.node}"`], action.nodeObj);
  case SET_TEST:
    // console.log('SET_NODES_OBJS_BY_NODE');
    return state
      .setIn(['data', 'test', `${action.key}`], action.foo);
  case SET_NODEOBJSBYRANGE:
    // console.log('SET_NODEOBJSBYRANGE');
    return state
      .setIn(['data', 'nodeObjsByRange'], action.nodeObjsByRange);
  case SET_COUNTOF:
    // console.log('SET_COUNTOF');
    return state
      .setIn(['data', 'countOf'], action.countOf);
  case SET_EDGES:
    // console.log('SET_EDGES');
    return state
      .setIn(['data', 'edges', 'left'], action.edges.left)
      .setIn(['data', 'edges', 'top'], action.edges.top)
      .setIn(['data', 'edges', 'right'], action.edges.right)
      .setIn(['data', 'edges', 'bottom'], action.edges.bottom)
      .setIn(['data', 'edges', 'leftNode'], action.edges.leftNode)
      .setIn(['data', 'edges', 'rightNode'], action.edges.rightNode);
  case SET_FOCUSNODE:
    // console.log('SET_FOCUSNODE');
    return state.setIn(['data', 'focusNode'], action.focusNode);
  case SET_CID_GRPS:
    return state.setIn(['data', 'cidsGrps'], action.cidsGrps);
  case SET_FIRSTTREEMATCHCOUNTNODE:
    // console.log('SET_FIRSTTREEMATCHCOUNTNODE');
    return state.setIn(['data', 'firstTreeMatchCountNode'], action.firstTreeMatchCountNode);
  case SET_FIRSTRECORDMATCHCOUNTNODE:
    // console.log('SET_FIRSTRECORDMATCHCOUNTNODE');
    return state.setIn(['data', 'firstRecordMatchCountNode'], action.firstRecordMatchCountNode);
  case SET_FIRSTMALEGHOSTNODE:
    // console.log('SET_FIRSTMALEGHOSTNODE');
    return state.setIn(['data', 'firstMaleGhostNode'], action.firstMaleGhostNode);
  case SET_FIRSTFEMALEGHOSTNODE:
    // console.log('SET_FIRSTFEMALEGHOSTNODE');
    return state.setIn(['data', 'firstFemaleGhostNode'], action.firstFemaleGhostNode);
  case SET_FIRSTTREEMATCHNODE:
    // console.log('SET_FIRSTTREEMATCHNODE');
    return state.setIn(['data', 'firstTreeMatchNode'], action.firstTreeMatchNode);
  case SET_FIRSTDEADNODE:
    // console.log('SET_FIRSTDEADNODE');
    return state.setIn(['data', 'firstDeadNode'], action.firstDeadNode);
  case SET_FIRSTRECORDMATCHNODE:
    // console.log('SET_FIRSTRECORDMATCHNODE');
    return state.setIn(['data', 'firstRecordMatchNode'], action.firstRecordMatchNode);
  case SET_FIRSTSMARTMATCHNODE:
    // console.log('SET_FIRSTSMARTMATCHNODE');
    return state.setIn(['data', 'firstSmartMatchNode'], action.firstSmartMatchNode);
  case SET_FIRSTCYCLEMASTERNODE:
    // console.log('SET_FIRSTCYCLEMASTERNODE');
    return state.setIn(['data', 'firstCycleMaster'], action.firstCycleMaster);
  case SET_FIRSTMULTIPLEPARENTNODE:
    // console.log('SET_FIRSTMULTIPLEPARENTNODE');
    return state.setIn(['data', 'firstMultipleParentNode'], action.firstMultipleParentNode);
  case SET_FIRSTCONFLICTNODE:
    // console.log('SET_FIRSTCONFLICTNODE');
    return state.setIn(['data', 'firstConflictNode'], action.firstConflictNode);
  case SET_FIRSTDNANODE:
    // console.log('SET_FIRSTDNANODE');
    return state.setIn(['data', 'firstDNANode'], action.firstDNANode);

  case FIRSTEDITNODE:
    // console.log('FIRSTEDITNODE');
    return state.setIn(['data', 'firstEditNode'], action.firstEditNode);

  case FIRSTEMAILREQUESTNODE:
    // console.log('FIRSTEMAILREQUESTNODE');
    return state.setIn(['data', 'firstEmailRequestNode'], action.firstEmailRequestNode);

  case SET_FIRSTINCONSISTENTENCYNODE:
    // console.log('SET_FIRSTINCONSISTENTENCYNODE');
    return state.setIn(['data', 'firstInconsistentencyNode'], action.firstInconsistentencyNode);

  case SET_FIRSTMERGEPENDINGNODE:
    // console.log('SET_FIRSTMERGEPENDINGNODE');
    return state.setIn(['data', 'firstMergePendingNode'], action.firstMergePendingNode);

  case SET_FIRSTAPPEAR05NODE:
    // console.log('SET_FIRSTAPPEAR05NODE');
    return state.setIn(['data', 'firstAppear05Node'], action.firstAppear05Node);

  case SET_FIRSTAPPEAR06NODE:
    // console.log('SET_FIRSTAPPEAR06NODE');
    return state.setIn(['data', 'firstAppear06Node'], action.firstAppear06Node);

  case SET_FIRSTAPPEAR07NODE:
    // console.log('SET_FIRSTAPPEAR07NODE');
    return state.setIn(['data', 'firstAppear07Node'], action.firstAppear07Node);

  case SET_FIRSTAPPEAR08NODE:
    // console.log('SET_FIRSTAPPEAR08NODE');
    return state.setIn(['data', 'firstAppear08Node'], action.firstAppear08Node);

  case SET_FIRSTAPPEAR09NODE:
    return state.setIn(['data', 'firstAppear09Node'], action.firstAppear09Node);

  case SET_NUMOFGENERATIONS:
    return state.setIn(['data', 'numOfGenerations'], action.numOfGenerations);

  case SET_LOOKUPNODEID:
    // console.log('SET_LOOKUPNODEID');
    return state
      .setIn(['data', 'loaded'], true)
      .setIn(['data', 'lookUpNodeId'], action.lookUpNodeId);
  case SET_PROFILE_OBJS:
    // console.log('SET_PROFILE_OBJS');
    return state
      .setIn(['data', 'loaded'], true)
      .setIn(['data', 'profileObjs'], action.profileObjs);
  case SET_FLIPDATA:
    // console.log('SET_FLIPDATA');
    return state
      .setIn(['data', 'flipBoxData'], action.flipData);
  case SET_VIEWPORT:
    // console.log('SET_VIEWPORT');
    return state
      .setIn(['ui', 'viewport', 'top'], action.viewport.top)
      .setIn(['ui', 'viewport', 'right'], action.viewport.right)
      .setIn(['ui', 'viewport', 'bottom'], action.viewport.bottom)
      .setIn(['ui', 'viewport', 'left'], action.viewport.left);
  case SET_PROGRESS:
    // console.log('SET_PROGRESS');
    return state
      .setIn(['ui', 'progress', 'loaded'], action.progress.loaded)
      .setIn(['ui', 'progress', 'show'], action.progress.show)
  case SET_PREFERENCES:

    let latestState = state;
    let getLatestState = (state, key, value) => {
      return state.setIn(['user', key], value)
    };

    for (var key in action.preferencesData) {
      latestState = getLatestState(latestState, key, action.preferencesData[key]);
    }

    // console.log(`latestState: `, JSON.stringify(latestState, null, 2));
    return latestState;

  case SET_RESOLVE:
    // console.log('SET_RESOLVE');
    return state
      .setIn(['user', 'resolve', 'focusPrId'], action.focusPrId)
      .setIn(['user', 'resolve', 'parents'], action.parents)
      .setIn(['user', 'resolve', 'partners'], action.partners)
      .setIn(['user', 'resolve', 'siblings'], action.siblings)
      .setIn(['user', 'resolve', 'children'], action.children)
  case SET_FLOATERS:
    // console.log('SET_FLOATERS');
    return state
      .setIn(['user', 'floaters'], action.floaters)
  case SET_LEGEND_DESCRIPTIONS:
    return state
      .setIn(['user', 'legendDescriptions'], action.legendDescriptions)
  case SET_CANVAS_WIDTH:
    // console.log('SET_CANVAS_WIDTH');
    return state
      .setIn(['ui', 'canvas', 'width'], action.canvas.width);
  case SET_CANVAS_HEIGHT:
    // console.log('SET_CANVAS_HEIGHT');
    return state
      .setIn(['ui', 'canvas', 'height'], action.canvas.height);
  case SET_CANVAS_HEIGHT_TOP:
    // console.log('SET_CANVAS_HEIGHT_TOP');
    return state
      .setIn(['ui', 'canvas', 'top'], action.canvas.top)
      .setIn(['ui', 'canvas', 'height'], action.canvas.height);
  default:
    return state;
  }

}

export default treeReducer;
